import { AUTH_ROUTES } from '../../constants/routePaths'
import auth_types from '../../constants/authTypes'
import forms_types from '../../constants/formsTypes'
import {axios, reset_axios} from '../../services'

import { preferences_index } from '../preferencesActions'

const login_request = () => {
  return {
    type: auth_types.LOGIN.request
  }
}

const login_success = (response) => {
  return {
    type: auth_types.LOGIN.success,
    payload: response
  }
}

const login_failure = (messages) => {
  return {
    type: auth_types.LOGIN.failure,
    payload: messages
  }
}

const loginEmail = (value) => {
  return {
    type: forms_types.login.mail,
    payload: value
  }
}


const persist_user = (data) => {
  const userdata = {
    "email": data["email"],
    "token": data["token"]
  }
  localStorage.setItem('userdata', JSON.stringify(userdata))
  reset_axios()
}

const loginUser = (logindata) => {
  return function (dispatch ) {
    // REQUEST
    dispatch(login_request())

    let { email, password } = logindata
    axios(
      {
        url: AUTH_ROUTES.login,
        method: 'POST',
        data: {
          user: {
            email: email,
            password: password
          }
        }
      }
    ).then( response => {
      // SUCCESS
      persist_user( response.data )
      dispatch( login_success( response ) )
      dispatch( preferences_index() )
    }).catch( error => {
      let errors
      if (error.response && error.response.data && error.response.data.errors) {
        errors = error.response.data.errors
      } else if (error.response && error.response.data) {
        errors = [error.response.data]
      } else {
        errors = ["Login failed."]
      }
      // FAILURE
      dispatch( login_failure( errors ) )
    })
  }

}

export {
  loginUser,
  loginEmail
 }



// WEBPACK FOOTER //
// ./src/js/actions/auth/auth_login.js